import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { Sale, SaleDetail } from '@sc/types';
import { WalletService } from '../../services/wallet/wallet.service';
import { OrganizationsService } from '../../services/organizations/organizations.service';
import { SalesService } from '../../services/sales/sales.service';
import { SalesInfoPage } from '../../modals/sales-info/sales-info.page';
import { AnalyticsService } from '../../services/analytics/analytics.service';

@Component({
  selector: 'sc-sales-card',
  templateUrl: './sales-card.component.html',
  styleUrls: ['./sales-card.component.scss'],
})
export class SalesCardComponent implements OnInit, OnDestroy {
  @Input() sale: Sale;
  @Input() appearance: 'auth' | 'subscription' | 'checkout' | 'upgrade';
  @Input() disabled: boolean;

  dashboardOrg$ = this.organizationsService.dashboardOrg$;

  redeemedCoupons = [];
  reactivatingSubscription = false;

  isCouponRedeemed = false;

  subs: Array<Subscription> = [];

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private walletService: WalletService,
    private organizationsService: OrganizationsService,
    private salesService: SalesService,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.checkCouponRedeemed();
    this.setupCard();
  }

  setupCard() {
    const saleContainer: HTMLElement = document.getElementById('sales-card');
    if (!saleContainer) return;
    const childSalesContainer = saleContainer.children[0];
    this.renderer.setStyle(childSalesContainer, 'background-color', this.sale.style.backgroundColor);
    this.renderer.setStyle(childSalesContainer, '--card-color', this.sale.style.backgroundColor);
    this.renderer.setStyle(childSalesContainer, 'background-image', `url('${this.sale.style.backgroundPattern}')`);
  }

  async checkCouponRedeemed() {
    const org = await this.organizationsService.dashboardOrg$.toPromise();
    const couponCheck = await this.salesService.checkIfCouponRedeemed(org.orgID);
    this.isCouponRedeemed = couponCheck;
  }

  select() {
    if (this.appearance === 'subscription') {
      this.router.navigate(['/upgrade?yearly=', true]);
    }
  }

  async openSaleInfoModal() {
    const modal = await this.modalController.create({
      component: SalesInfoPage,
      componentProps: {
        sale: this.salesService.currentSale$.value,
      },
      showBackdrop: true,
      backdropDismiss: true,
      animated: true,
      cssClass: 'sales-info-modal',
    });
    await modal.present();
    await this.popoverController.dismiss();
    await this.analyticsService.track('opened sales info');
  }

  /*
   * Prevents flickering/flashing in the list
   *
   * @param index - number
   * @param saleDetail - SaleDetail
   * @returns - number
   */
  trackSaleDetailsBy(index: number, saleDetail: SaleDetail) {
    return saleDetail.id;
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
